import { render, staticRenderFns } from "./declareExpert.vue?vue&type=template&id=d27f1d12&"
import script from "./declareExpert.vue?vue&type=script&lang=js&"
export * from "./declareExpert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports